<h5 mat-dialog-title i18n>Payroll Summary Report</h5>
<div mat-dialog-content>
  <p i18n>Please define the filters below</p>
  <form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
    <div class="form-group row">
      <div class="col-sm-6">
        <div class="control-wrapper">
          <label for="quote_ID" class="col-sm-3 col-form-label" i18n>Job</label>
          <select name="quote_ID"
                  [(ngModel)]="data.payrollSummary.quote_ID" #quote_ID="ngModel"
                  class="form-control select-bidit">
            <option [ngValue]="undefined" i18n>All</option>
            <option *ngFor="let job of data.jobs" [ngValue]="job.quote_ID">{{job.quote_Name}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="crew_ID" class="col-sm-3 col-form-label" i18n>Crew</label>
          <select name="crew_ID"
                  [(ngModel)]="data.payrollSummary.crew_ID" #crew_ID="ngModel"
                  class="form-control select-bidit">
            <option [ngValue]="undefined" i18n>All</option>
            <option *ngFor="let crew of data.crews" [ngValue]="crew.crew_ID">{{crew.crew_Name}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="fieldTechnician_ID" class="col-sm-3 col-form-label" i18n>Field Technician</label>
          <select name="fieldTechnician_ID"
                  [(ngModel)]="data.payrollSummary.fieldTechnician_ID" #fieldTechnician_ID="ngModel"
                  class="form-control select-bidit">
            <option [ngValue]="undefined" i18n>All</option>
            <option *ngFor="let fieldTechnician of data.fieldTechnicians" [ngValue]="fieldTechnician.fieldTechnician_ID">
              {{fieldTechnician.fieldTechnician_FirstName}} {{fieldTechnician.fieldTechnician_LastName}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <p i18n>Define Time Frame</p>
        <div class="control-wrapper">
          <label for="startDate" class="col-sm-3 col-form-label" i18n>Start Date</label>
          <div class="form-inline">
            <input name="startDate" id="startDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="startPicker"
                   [(ngModel)]="data.startDate" #startDate="ngModel" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </div>
        </div>
        <div class="control-wrapper">
          <label for="endDate" class="col-sm-3 col-form-label" i18n>End Date</label>
          <div class="form-inline">
            <input name="endDate" id="endDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="endPicker"
                   [(ngModel)]="data.endDate" #endDate="ngModel" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="errors" class="alert alert-danger">
      {{errors}}
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
      <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>

